import React from 'react';

export const CheckoutStateContext = React.createContext([]);
export const CheckoutDispatchContext = React.createContext(() => {});